import React from 'react';
import { SkeletonItem } from '@fluentui/react-components';
import './ChatListEntry.scss';

export const ChatListEntrySkeleton: React.FC = () => {
  return (
    <div className="ChatListEntry" aria-hidden>
      <SkeletonItem shape="circle" size={48} />
      <div className="inner">
        <div className="titleWrapper">
          <SkeletonItem shape="rectangle" size={20} />
        </div>

        <SkeletonItem shape="rectangle" size={20} />
      </div>
    </div>
  );
};
